<template>
    <form-row title="Total Monthly Payments">
        <input-money
            :value="mortgage.total_monthly_payments"
            name="total_monthly_payments"
            :read_only="read_only"
        />

        <div class="mt-4 sm:mt-0 flex flex-1 items-center text-sm text-gray-warm-800 sm:pl-10">
            Please verify this when Closing Disclosure is received.
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        mortgage: {},
        read_only: { default: false },
    },
}
</script>
